import { useState } from 'react'
import { Header } from '@/components/DashboardComponents'
import { Button, RoundIconButton, Textbox } from '@/form/FormComponents'
import { useNavigate, useLoaderData, useRouteLoaderData } from 'react-router'
import { GenericEmptyListPlaceholder } from '@/DashboardLayout'
import { useModal, Modal, ModalContent, ModalButtons, ModalListItem, useErrorModal } from '@/components/Modal'
import { useMenu } from '@/components/Menu'
import { Icon } from '@/components/Icon'
import { FormProvider, FormSubmitProvider } from '@/form/FormProvider'
import { renameScenario, trashScenario } from '@/data/ScenarioData'
import { useIsDeveloper, useUser } from '@/systems/Authentication'
import { useListThenJoinDepartmentModal } from '@/pages/SettingsLayout'
import { publicAction } from '@/data/loaders'
import { useIsMobile, useBreakpoint } from '@/hooks/useIsMobile'

export function Scenarios() {
  const navigate = useNavigate();
  const scenarios = useLoaderData().data.value;
  const sample_scenarios = useLoaderData().data.sample_scenarios || [];
  const { userdata } = useUser();

  const [loading_join_department, setLoadingJoinDepartment] = useState(false);

  const { handleJoinDepartment } = useListThenJoinDepartmentModal({ setLoadingJoinDepartment });

  const [openContactUsModal] = useModal(function({ closeModal }) {
    return (
      <Modal title="Contact us">
        <ModalContent>
          Please email us at <a href="mailto:contact@sapientclinician.com" className="links">contact@sapientclinician.com</a>.
        </ModalContent>
        <ModalButtons>
          <Button text="Dismiss" onClick={closeModal}/>
        </ModalButtons>
      </Modal>
    )
  })

  const banner = null;
  // const banner = ((userdata.is_educator && userdata.organizations.length == 0) ? (
  //   userdata.organization_id ? (
  //     userdata.organizations_pending.length > 0 ? (
  //       <div className="callout_hint_box">
  //         <div>
  //           <div><Icon name="domain"/></div>
  //           <div>{`Your account is limited until you join a department and gain educator access. Your request to join ${userdata.organizations_pending[0].data.name} is still pending.`}</div>
  //           <div>
  //             <Button text="Review request" className="hollow" onClick={() => navigate("/settings/organizations")}/>
  //           </div>
  //         </div>
  //       </div>
  //     ) : (
  //       <div className="callout_hint_box">
  //         <div>
  //           <div><Icon name="domain"/></div>
  //           <div>{`Your account is limited until you join a department and gain educator access. Please join or sign up your department.`}</div>
  //           <div>
  //             <Button text="Join a department" className="hollow" onClick={handleJoinDepartment} loading={loading_join_department}/>
  //           </div>
  //         </div>
  //       </div>
  //     )
  //   ) : (
  //     // <div className="callout_hint_box">
  //     //   <div>
  //     //     <div><Icon name="domain"/></div>
  //     //     {/* <div>{`Your account is limited without educator access. Sign up your organization to gain educator access.`}</div> */}
  //     //     <div>{`You have a free trial account. Sign up as an individual, team, or department for full access.`}</div>
  //     //   </div>
  //     // </div>

  //     <div className="callout_hint_box">
  //       <div style={{alignItems: "center"}}>
  //         <div><Icon name="gift-outline"/></div>
  //         <div>{`You’re on a free trial. Contact us to unlock full access for yourself, your team, or your department.`}</div>
  //         <div style={{marginTop: "-6px", marginBottom: "-6px"}}>
  //           <Button text="Contact us" className="small hollow" onClick={openContactUsModal}/>
  //         </div>
  //       </div>
  //     </div>
  //   )
  // ) : null)

  const [show_sample_scenarios, setShowSampleScenarios] = useState(scenarios.length < 2 || userdata.email === "demo@sapientclinician.com");

  const hide_date = useBreakpoint((width) => width <= 800);
  const hide_assigned_to = useBreakpoint((width) => width <= 600);

  return (
    <>
      <Header title="My scenarios" no_shadow={true}>
        <Button className="primary" icon="plus" text="New scenario" onClick={() => navigate("/scenarios/new")}/>
      </Header>
      <div className="dashboard_content_inner nearest_scrollable_container">
        <div className="scenario_list full_page_list" columns={3 - (hide_date ? 1 : 0) - (hide_assigned_to ? 1 : 0)}>
          {banner ? (
            <div className="scenario_list_header_banner scroller_shadow_offset_height">
              {banner}
            </div>
          ) : null}
          <div className="scenario_list_header">
            <div></div>
            <div>Title</div>
            {!hide_date && <div>Date created</div>}
            {!hide_assigned_to && <div>Assigned to</div>}
            <div></div>
          </div>
          {scenarios.sort((a, b) => b.date_created - a.date_created).map((scenario) => <ScenarioItem key={scenario._id} scenario={scenario}/>)}
        </div>
        {scenarios.length == 0 ? <GenericEmptyListPlaceholder text="You haven't created any scenarios yet" inline={true}/> : null}
        {sample_scenarios.length > 0 ? <>
          <div className="toggle_expand_header" onClick={() => setShowSampleScenarios(!show_sample_scenarios)} tabIndex={0}><div>Sample case scenarios</div><div><Icon name={show_sample_scenarios ? "chevron-up" : "chevron-down"}/></div></div>
          <div className="scenario_list full_page_list" columns="1" style={{display: show_sample_scenarios ? "" : "none"}}>
            {sample_scenarios.map((scenario) => <ScenarioItem key={scenario._id} scenario={scenario} is_sample={true}/>)}
          </div>
        </> : null}
      </div>
    </>
  )
}

function ScenarioItem({scenario, is_sample = false}) {
  const navigate = useNavigate();
  const [openErrorModal] = useErrorModal();

  const courses = useRouteLoaderData("dashboard_root").data.value;
  const educator_courses = courses.filter((course) => course.membership_type == "educator" && !course.archived);

  const [openDownloadModal] = useCopyPromptModal({ title: scenario.data.title, text: scenario._dev_details_prompt, filename: scenario.data.title });

  const [openAssignScenarioModal] = useModal(({ context, closeModal }) => {
    return (
      <Modal title="Assign scenario">
        <ModalContent>
          {educator_courses.length > 0 ? (
            [...educator_courses].sort((a, b) => a.name.localeCompare(b.name)).map((course) => <ModalListItem key={course._id} icon="book-open-variant-outline" text={course.name+(course.section_name ? ` (${course.section_name})` : "")} onClick={() => {closeModal();navigate(`/courses/${course._id}/assessments/new/${context.assign_scenario_id}`);}}/>)
          ) : "You aren't a teacher in any courses."}
        </ModalContent>
        <ModalButtons>
          <Button text="Cancel" className="hollow" onClick={closeModal}/>
        </ModalButtons>
      </Modal>
    )
  })

  function handleAssignScenario(scenario) {
    openAssignScenarioModal({ assign_scenario_id: scenario._id });
  }

  const [openRenameScenarioModal] = useModal(function ({ context, closeModal, setLoading }) {
    function submitRenameScenario({formatted_data, focusError}) {
      setLoading(true);
  
      renameScenario({ id: context.scenario_id, title: formatted_data.title }).then(function(data) {
        closeModal();
        navigate('.', { replace: true });
      }).catch(function(error) {
        console.error(error);
        setLoading(false);
        focusError({name: "title", error: "Something went wrong, please try again."});
      });
    }

    return (
      <Modal title="Rename scenario">
        <FormProvider onSubmit={submitRenameScenario}>
          <FormSubmitProvider>
            {({handleSubmit}) => (
              <>
                <ModalContent>
                  <Textbox name="title" onEnter={handleSubmit} default_value={context.scenario_title} required="Please enter a scenario title" />
                </ModalContent>
                <ModalButtons>
                  <Button text="Cancel" className="hollow" onClick={closeModal}/>
                  <Button text="Submit" className="primary" onClick={handleSubmit}/>
                </ModalButtons>
              </>
            )}
          </FormSubmitProvider>
        </FormProvider>
      </Modal>
    )
  })

  function handleRenameScenario(scenario) {
    openRenameScenarioModal({ scenario_id: scenario._id, scenario_title: scenario.data.title });
  }

  const [openTrashScenarioModal] = useModal(function ({ context, closeModal, setLoading }) {
    function submitTrashScenario() {
      setLoading(true);
  
      trashScenario({ id: context.scenario_id }).then(function(data) {
        closeModal();
        navigate('.', { replace: true });
      }).catch(function(error) {
        console.error(error);
        closeModal();
        openErrorModal();
      });
    }

    return (
      <Modal title="Move scenario to trash?">
        <ModalContent>
          Items in the trash will be deleted forever after 30 days.
        </ModalContent>
        <ModalButtons>
          <Button text="Cancel" className="hollow" onClick={closeModal}/>
          <Button text="Confirm" className="primary" onClick={submitTrashScenario}/>
        </ModalButtons>
      </Modal>
    )
  })

  function handleTrashScenario(scenario) {
    openTrashScenarioModal({ scenario_id: scenario._id });
  }

  const [openCopyScenarioModal] = useModal(function ({ context, closeModal, setLoading }) {
    function submitRenameScenario({formatted_data, focusError}) {
      setLoading(true);
  
      publicAction("duplicateScenario", { id: context.scenario_id, title: formatted_data.title }).then(function(data) {
        closeModal();
        navigate('.', { replace: true });
      }).catch(function(error) {
        console.error(error);
        setLoading(false);
        focusError({name: "title", error: "Something went wrong, please try again."});
      });
    }

    return (
      <Modal title="Make a copy of scenario">
        <FormProvider onSubmit={submitRenameScenario}>
          <FormSubmitProvider>
            {({handleSubmit}) => (
              <>
                <ModalContent>
                  <Textbox title="New scenario title" name="title" onEnter={handleSubmit} default_value={"Copy of "+context.scenario_title} required="Please enter a scenario title" />
                </ModalContent>
                <ModalButtons>
                  <Button text="Cancel" className="hollow" onClick={closeModal}/>
                  <Button text="Submit" className="primary" onClick={handleSubmit}/>
                </ModalButtons>
              </>
            )}
          </FormSubmitProvider>
        </FormProvider>
      </Modal>
    )
  })

  function handleCopyScenario(scenario) {
    openCopyScenarioModal({ scenario_id: scenario._id, scenario_title: scenario.data.title });
  }

  const is_dev = useIsDeveloper();
  const { handleContextMenu, handleOnClick } = useMenu({
    menuItems: is_sample ? (
      [
        {
          label: 'Try it out',
          icon: 'play-outline',
          onClick: () => navigate(`/scenarios/${scenario._id}/preview`),
        },
        "separator",
        {
          label: 'Make a copy',
          icon: 'copy',
          onClick: () => handleCopyScenario(scenario),
        },
      ]
    ) : (
      [
        {
          label: 'Edit',
          icon: 'pencil-outline',
          onClick: () => navigate(`/scenarios/${scenario._id}`),
        },
        {
          label: 'Preview',
          icon: 'play-outline',
          onClick: () => navigate(`/scenarios/${scenario._id}/preview`),
        },
        {
          label: 'Assign',
          icon: 'book-open-plus-variant-outline',
          onClick: () => handleAssignScenario(scenario),
        },
        "separator",
        {
          label: 'Rename',
          icon: 'rename-outline',
          onClick: () => handleRenameScenario(scenario),
        },
        {
          label: 'Make a copy',
          icon: 'copy',
          onClick: () => handleCopyScenario(scenario),
        },
        // "separator",
        // {
        //   label: 'Share',
        //   icon: '',
        //   onClick: () => handleShareScenario(scenario),
        // },
        // {
        //   label: 'Move',
        //   icon: '',
        //   onClick: () => handleMoveScenario(scenario),
        // },
        "separator",
        {
          label: 'Move to trash',
          icon: 'trash-can-outline',
          onClick: () => handleTrashScenario(scenario),
        },
        ...(is_dev ? [
          "separator",
          {
            label: 'Download as text',
            icon: 'file-download-outline',
            onClick: openDownloadModal,
          }
        ] : [])
      ]
    )
  });

  const is_mobile = useIsMobile();
  const hide_date = useBreakpoint((width) => width <= 800);
  const hide_assigned_to = useBreakpoint((width) => width <= 600);

  const assigned_to_course_ids = [...new Set((scenario.linked_assessments || []).filter(a => a.in_sync != null ? a.in_sync : true).map(a => a.course_id).reverse())].reverse(); // Remove the duplicates, keeping the latest index of each instead of the earliest index
  const assigned_to_course_names = assigned_to_course_ids.map(course_id => courses.find(course => course._id == course_id)?.name);
  const linked_course_name = assigned_to_course_names.filter(name => name).pop() || null;

  return (
    <div className="scenario_item" onClick={is_sample ? handleContextMenu : () => {navigate("/scenarios/"+scenario._id)}} onContextMenu={handleContextMenu} tabIndex={0}>
      <div className="item_icon">
        <Icon name="forum-outline"/>
      </div>
      <div className="item_title">{scenario.data.title}</div>
      {(!is_sample && !hide_date) && <div className="item_date">{(new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: 'numeric' }).format(scenario.date_created))}</div>}
      {(!is_sample && !hide_assigned_to) && <div className="item_date item_pills">{
        assigned_to_course_ids.length > 0 ? (
          linked_course_name ? 
            (<><div className="linked_course_pill"><div><Icon name="book-open-variant-outline"/></div><div>{linked_course_name}</div></div>{assigned_to_course_ids.length > 1 ? ` +${assigned_to_course_ids.length-1}` : ""}</>) : 
            `${assigned_to_course_ids.length} course${assigned_to_course_ids.length > 1 ? "s" : ""}`
          )
        : "-"
      }</div>}
      <div className="item_actions">
        {!is_mobile && <>
          <Button backgroundColor={"var(--header)"} icon="play-outline" text={is_sample ? "Try it out" : "Preview"} className="small hollow" onClick={(event) => {event.stopPropagation(); navigate("/scenarios/"+scenario._id+"/preview")}} />
          {is_sample ? (
            <Button backgroundColor={"var(--header)"} icon="copy" text="Make a copy" className="small hollow" onClick={(event) => {event.stopPropagation(); handleCopyScenario(scenario)}} />
          ) : (
            <Button backgroundColor={"var(--header)"} icon="book-open-plus-variant-outline" text="Assign" className="small hollow" onClick={(event) => {event.stopPropagation(); handleAssignScenario(scenario)}} />
          )}
        </>}
      </div>
      <div className="item_more">
        <RoundIconButton icon="dots-vertical" className="small" onClick={handleOnClick} />
      </div>
    </div>
  )
}

export function useCopyPromptModal({ title, text, filename }) {
  const [openDownloadModal] = useModal(({ closeModal }) => {
    function copyText() {
      navigator.clipboard.writeText(text);
      closeModal();
    }

    function saveTextAsFile() {
      const element = document.createElement('a');
      const file = new Blob([text], {type: 'text/plain'});
      element.href = URL.createObjectURL(file);
      element.download = `${filename}.txt`;
      document.body.appendChild(element); // Required for this to work in FireFox
      element.click();
      document.body.removeChild(element);
      closeModal();
    }

    return (
      <Modal title={title}>
        <ModalContent>
          <Textbox value={text} readOnly={true} multiline={true} height={12} />
        </ModalContent>
        <ModalButtons>
          <Button icon="copy" text="Copy" onClick={copyText}/>
          <Button icon="file-download-outline" text="Save file" onClick={saveTextAsFile}/>
        </ModalButtons>
      </Modal>
    )
  });

  return [openDownloadModal];
}